<template>
  <div class="OverviewsItem OverviewsAccesesItemTeamMember flex justify-between items-center space-x-2 w-full max-w-full hover:bg-gray-100 border-b border-gray-400 px-2">
    <div class="OverviewsItemPictogram flex justify-center items-center mr-2.5">
      <ui-pictogram :user="visit.user"/>
    </div>
    <div class="OverviewsItemLabelWrapper flex justify-between items-center w-full text-sm space-x-2">
      <span class="truncate">
        {{ visit.user.label }}
      </span>
      <span 
        v-if="visit.last_visit"
        class="truncate mr-1.5 text-gray-400"
      >
        {{ $t('Last visit') }}: {{ formatDate(visit.last_visit, 'd. m. Y') }}
      </span>
    </div>
    <div class="flex justify-end items-center text-sm space-x-1">
      <aw-icon
        :icon="visit.edit ? 'pen' : 'eye-opened'"
        class="w-6 h-6 text-bc-blue"
      />
      <aw-icon 
        icon="download" 
        class="w-6 h-6 text-gray-400"
        :class="visit.download ? 'text-bc-blue' : 'text-gray-400'"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visit: Object,
  },
  data() {
    return {
    }
  },
  computed: {
    name() {
      if (this.visit.user.name && this.visit.user.surname) {
        return this.visit.user.name + ' ' + this.visit.user.surname
      }

      return this.visit.user.email 
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.OverviewsAccesesItemTeamMember {
  .OverviewsItemLabelWrapper {
    max-width: calc(100% - 1.625rem - 78px);
  }
}
</style>
